import styled from "styled-components";

export const AboutSectionWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  @media only screen and (max-width: 931px) {
    & {
      flex-direction: column;
      overflow-y: auto;
    }
  }
`;

export const AboutSectionLeft = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 931px) {
    & {
      width: 100%;
    }
  }

  & div:first-child {
    width: 70%;
    height: auto;
    margin: 0 auto;
    background: #212225;
    padding: 5rem 2rem;

    & h1 {
      font-family: "Aladin", cursive;
      margin-bottom: 1.5rem;
      color: #3fca89;
    }

    & a {
      width: auto;
      height: auto;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-right: 1.5rem;
      padding: 0.5rem 2rem;
      border: 1px solid #3fca89;
      border-radius: 4px;
      color: #3fca89;
      text-decoration: none;
      transition: all 0.2s ease;

      & svg {
        margin-right: 1rem;
      }

      &:hover {
        background: #3fca89;
        color: #fff;
        transform: translateY(-5px);
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);
      }
    }
  }
`;

export const AboutSectionRight = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 931px) {
    & {
      width: 100%;
    }
  }

  & > h1 {
    font-family: "Aladin", cursive;
    margin-bottom: 1.5rem;
    margin-left: 2rem;
    color: #3fca89;
    align-self: flex-start;
    text-decoration: underline;

    @media only screen and (max-width: 612px) {
      & {
        margin-top: 5rem;
        align-self: center;
      }
    }
  }
`;

export const ServiceList = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;

  @media only screen and (max-width: 612px) {
    & {
      display: block;
    }
  }
`;

export const ServiceCard = styled.div`
  width: calc(50% - 4rem);
  margin: 2rem;
  padding: 2rem;
  border-radius: 4px;

  @media only screen and (max-width: 612px) {
    & {
      width: calc(100% - 4rem);
    }
  }

  & h1 {
    font-family: "Aladin", cursive;
    margin-bottom: 1.5rem;
    font-size: 2rem;
    color: #3fca89;
  }

  & p {
    font-size: 1.4rem;
  }
`;
